import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
} from '@angular/core';
import { BypassBlockComponent } from '@rd/core/components/bypass-block/bypass-block.component';

@Component({
  selector: 'rd-westpac-bypass-block',
  templateUrl: './bypass-block.component.html',
  styleUrls: ['./bypass-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WestpacBypassBlockComponent extends BypassBlockComponent {
  @HostBinding('class.westpac-core-bypass-block') componentClass = true;

  constructor(@Inject(DOCUMENT) protected document: any) {
    super(document);
  }
}
